import { render } from "./LaborersList.vue?vue&type=template&id=2da8d168"
import script from "./LaborersList.vue?vue&type=script&lang=js"
export * from "./LaborersList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/luqiao/laborers/laborers/LaborersList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2da8d168"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2da8d168', __exports__)) {
    api.reload('2da8d168', __exports__)
  }
  
  module.hot.accept("./LaborersList.vue?vue&type=template&id=2da8d168", () => {
    api.rerender('2da8d168', render)
  })

}


export default __exports__